"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusChild = exports.focusFirstChild = exports.returnFocus = exports.focusLater = void 0;

var _tabbable = require("./tabbable");

var lastFocusedElement = undefined;

var focusLater = function focusLater() {
  lastFocusedElement = document.activeElement;
};

exports.focusLater = focusLater;

var returnFocus = function returnFocus() {
  if (lastFocusedElement) {
    lastFocusedElement.focus();
    lastFocusedElement = null;
  }
};

exports.returnFocus = returnFocus;

var focusFirstChild = function focusFirstChild(element) {
  var tabbable = (0, _tabbable.setTabbable)(element);
  tabbable.first.focus();
};

exports.focusFirstChild = focusFirstChild;

var focusChild = function focusChild(parent, selector) {
  var child = document.querySelector(selector);

  if (!parent.contains(child)) {
    console.error("".concat(selector, " is not a child of the specified parent.")); // eslint-disable-line

    return;
  }

  child.focus();
};

exports.focusChild = focusChild;